import { IModel, IAttribute, Collection } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';

import { AzureCosmosDbMongoDbApiDataset } from 'app/model/dataset/azure-cosmos-db-mongodb-api.dataset';
import { CopySource } from 'app/model/pipeline/copysource/copysource';
import { ParameterConfig } from '../parameter-config';
import { createParameterConfigurationValidator } from 'app/model/adapters/linkedservices/parameter-config.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.cosmosMongo.copySourceType,
    display: [],
    tags: { datasetModel: Metamodel.modelFor(AzureCosmosDbMongoDbApiDataset) }
})
export class AzureCosmosMongoDbApiCopySource extends CopySource {
    public static readonly MODEL: IModel;
    public static readonly BATCH_SIZE: IAttribute;
    public static readonly FILTER: IAttribute;
    public static readonly CURSORMETHODS: IAttribute;

    @Metamodel.attribute({
        templatable: true,
        association: 'BATCH_SIZE',

        display: stringResources.ModelName_BatchSize
    })
    public batchSize?: number = 100;

    @Metamodel.attribute({
        templatable: true,
        association: 'FILTER',

        display: stringResources.Filter
    })
    public filter?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CursorMethods,
        collection: Collection.Array,

        templatable: true,
        association: 'CURSORMETHODS',
        constraint: {
            validator: createParameterConfigurationValidator()
        }
    })
    public cursorMethods?: ParameterConfig[] = [];

    public constructor(name?: string, description?: string) {
        super(name, description);
    }
}
